import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import 'moment/locale/es';
import 'moment/locale/en-gb';
import * as en from './assets/locale/en/*.json'
import * as es from './assets/locale/es/*.json'
import * as directBankingEN from './assets/locale/en/directBanking/*.json'
import * as directBankingES from './assets/locale/en/directBanking/*.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        ...en,
        ...directBankingEN
      },
      es: {
        ...es,
        ...directBankingES
      }
    },
    supportedLngs:['en','es'],
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false,
    }
  });


export default i18n;